import tracking from '../../utils/tracking';

export default class LinkToggleClass {
  domRoot: any;
  params: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = domRoot;
    this.params = params;
    this.init();
  }

  init() {
    let togglerElements = Array.from(document.getElementsByClassName(this.params.elementsClass));
    let toggleClasses = this.params.classToToggle.trim().split(" ")
    let buttonClassToggler = this.domRoot.querySelector(".class-toggler");
    buttonClassToggler.addEventListener("click", (e: MouseEvent) => {
      e.preventDefault();
      let togglerText = buttonClassToggler.innerText.trim();
      tracking.trackEvent('toggleButton', {...buttonClassToggler.dataset, ...{label: togglerText}});
      togglerElements.forEach(element => {
        toggleClasses.forEach((toggleClass: string) => { 
          element.classList.toggle(toggleClass);
        });
      });
      (e.target as HTMLElement).innerText = togglerText == buttonClassToggler.getAttribute("data-showtext") ? buttonClassToggler.getAttribute("data-hidetext") : buttonClassToggler.getAttribute("data-showtext");
      (e.target as HTMLElement).classList.toggle("button-toggled");
    });
  }  
}
